import { observer } from 'mobx-react-lite';
import { Alert } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { MoneyDisplay } from '../starter-kit-selection/util-starter-kit/MoneyDisplay';

export enum WarningReasonType {
  AnyOrderRequired = 'AnyOrderRequired',
  EnrollmentOrderUnderPV = 'EnrollmentOrderUnderPV',
  EROrderUnderPV = 'EROrderUnderPV',
  ERPskAlert = 'ERPskAlert'
}

interface MeoWarningProps {
  type: WarningReasonType;
  minimumEnrollmentPv: number;
  minimumErPv: number;
}

export const MeoWarning = observer<MeoWarningProps>(props => {
  const { t } = useTranslation();

  switch (props.type) {
    case WarningReasonType.AnyOrderRequired:
      return (
        <Alert variant="warning">
          <Alert.Heading>{t('selectStarterKitWarningHeader')}</Alert.Heading>
          <p>{t('selectStarterKitWarningMessage')}</p>
        </Alert>
      );

    case WarningReasonType.EnrollmentOrderUnderPV:
      return (
        <Alert variant="warning">
          <Alert.Heading>{t('selectMinimumPVWarningHeader')}</Alert.Heading>
          <p>
            {t('selectMinimumPVWarningMessage1')} <MoneyDisplay numberOnly price={props.minimumEnrollmentPv} /> PV{' '}
            {t('selectMinimumPVWarningMessage2')} {t('selectMinimumPVWarningMessage4')}
          </p>
        </Alert>
      );

    case WarningReasonType.EROrderUnderPV:
      return (
        <Alert variant="warning">
          <Alert.Heading>{t('selectMinimumPVWarningHeader')}</Alert.Heading>
          <p>
            {t('selectMinimumPVWarningMessage1')} <MoneyDisplay numberOnly price={props.minimumErPv} /> PV{' '}
            {t('selectMinimumPVWarningMessage2')} {t('selectMinimumPVWarningMessage3')}{' '}
            {t('selectMinimumPVWarningMessage4')}
          </p>
        </Alert>
      );
      case WarningReasonType.ERPskAlert:
        return (
          <Alert variant="warning">
            <p> {t('selectSLWarningMessage')}</p>
          </Alert>
        );
  
  }
});
